import { Button } from '@consigli/facade';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { HiOutlineXMark } from 'react-icons/hi2';
import Popup from 'reactjs-popup';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  titleKey: string;
  messageKey: string;
  confirmLabelKey?: string;

  secondaryConfirmLabelKey?: string;
  onSecondaryConfirm?: () => void;
}

export const DeleteConfirmModal: FC<DeleteConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  titleKey,
  messageKey,
  confirmLabelKey,
  secondaryConfirmLabelKey,
  onSecondaryConfirm,
}) => {
  const { t } = useTranslation();
  const confirmLabel = confirmLabelKey
    ? t(confirmLabelKey)
    : t('meeting-secretary.meetings.delete');

  const hasSecondary = !!secondaryConfirmLabelKey && !!onSecondaryConfirm;

  return (
    <Popup
      overlayStyle={{ background: 'rgba(100, 100, 100, 0.35)' }}
      contentStyle={{
        backgroundColor: '#fbfcfd',
        borderRadius: '10px',
        width: '80%',
        maxWidth: '400px',
      }}
      modal
      open={isOpen}
      onClose={onClose}
    >
      <div className="flex flex-col flex-nowrap gap-y-4 p-4">
        <div className="flex flex-row justify-between items-start">
          <h2 className="font-bold text-xl text-day-neutral-dark">{t(titleKey)}</h2>
          <Button
            tertiary
            iconOnly
            icon={HiOutlineXMark}
            iconSize={24}
            onClick={onClose}
            aria-label={t('meeting-secretary.meetings.cancel', 'Close')}
          />
        </div>
        <p className="text-day-neutral-subtle whitespace-pre-line">{t(messageKey)}</p>
        {hasSecondary ? (
          <div className="flex flex-col gap-2 mt-2">
            <Button className="w-full" primary rounded onClick={onConfirm}>
              {confirmLabel}
            </Button>
            <Button className="w-full" secondary rounded onClick={onSecondaryConfirm}>
              {t(secondaryConfirmLabelKey)}
            </Button>
            <Button className="w-full" tertiary rounded onClick={onClose}>
              {t('meeting-secretary.meetings.cancel')}
            </Button>
          </div>
        ) : (
          <div className="flex gap-4 mt-2">
            <Button className="w-full" secondary rounded onClick={onClose}>
              {t('meeting-secretary.meetings.cancel')}
            </Button>
            <Button className="w-full" primary rounded onClick={onConfirm}>
              {confirmLabel}
            </Button>
          </div>
        )}
      </div>
    </Popup>
  );
};
